export const LANDING_STRINGS = {
    HERO_TITLE_1: "CENTRO",
    HERO_TITLE_2: "DIGITAL",
    HERO_TITLE_3: "INTELIGENTE",
    SUBTITLE: "La inteligencia de tu trabajo, en un solo lugar.",
    SIGN_IN_BUTTON_TOP: "Ingresar con Google",
    LEAD_TEXT: "Dralia unifica herramientas, conocimiento y asistentes de inteligencia artificial para:",
    TILE_1_LINE_1: "Acelerar el",
    TILE_1_LINE_2: "trabajo",
    TILE_1_LINE_3: "diario",
    TILE_1_BADGE: "UP",
    TILE_2_LINE_1: "Estandarizar",
    TILE_2_LINE_2: "procesos",
    TILE_3_LINE_1: "Facilitar la",
    TILE_3_LINE_2: "colaboración",
    TILE_3_LINE_3: "entre equipos",
    VISION_BADGE: "VISIÓN",
    VISION_TEXT: "Integrar personas, datos y automatización en una experiencia única que entregue respuestas confiables, trazables y accionables en segundos.",
    SIGN_IN_LEAD: "Inicia sesión con tu cuenta de Google",
    SIGN_IN_BUTTON: "Iniciar sesión",
    DRALIA: "DRALIA",
    BY_AYI_GROUP: "by AYI GROUP",
};

export const LOGIN_STRINGS = {
    LOGGED_IN_AS: "Iniciaste sesión como:",
    SIGN_IN: "Iniciar sesión",
    SIGN_OUT: "Cerrar sesión",
    WELCOME_TO_DRALIA: "Bienvenido a Dralia",
    SIGN_IN_WITH_GOOGLE: "Ingresar con Google",
};

export const CHATBOT_STRINGS = {
    SUGGESTION_1: 'Hola',
    SUGGESTION_2: 'Adiós',
    SUGGESTION_3: '¿Cuántos días de vacaciones me corresponden?',
    SUGGESTION_4: 'Quiero saber los beneficios de la empresa',
    USER_SENDER: 'User',
    BOT_SENDER: 'Null-E',
    BOT_ERROR_MESSAGE: 'Sorry, something went wrong.',
    BOT_NO_RESPONSE: 'No response from bot.',
    WELCOME_MESSAGE_PREFIX: 'Hola, '
};
